import { useState } from 'react'

import { useMountEffect } from './useMountEffect'

/** True while Cmd or Ctrl is held anywhere on the page. */
export function useModifierHeld() {
  const [held, setHeld] = useState(false)
  useMountEffect(() => {
    const sync = (e: KeyboardEvent) => setHeld(e.metaKey || e.ctrlKey)
    const release = () => setHeld(false)
    window.addEventListener('keydown', sync)
    window.addEventListener('keyup', sync)
    window.addEventListener('blur', release)
    return () => {
      window.removeEventListener('keydown', sync)
      window.removeEventListener('keyup', sync)
      window.removeEventListener('blur', release)
    }
  })
  return held
}
